export default "__VITE_ASSET__C79GP9SY__"